import { Controller } from "@hotwired/stimulus"
import { loadStripe } from "../lib/stripe_loader"

// The card's 3-D Secure step (TMS-1789, Payments::StripeController#authenticate). Stripe.js
// runs the bank's check for the PaymentIntent waiting on it; then the form posts back to the
// checkout, which reads the intent's outcome from Stripe rather than trusting this page.
export default class extends Controller {
  static targets = ["form", "status", "error", "continueButton"]
  static values = { publishableKey: String, clientSecret: String }

  async connect() {
    if (!this.clientSecretValue || !this.publishableKeyValue) {
      this.continue()
      return
    }

    try {
      const stripe = await loadStripe(this.publishableKeyValue)
      const { error } = await stripe.handleNextAction({ clientSecret: this.clientSecretValue })
      if (error) {
        this.showError(error.message || "Your card could not be verified.")
        return
      }
      this.continue()
    } catch (error) {
      console.error("Stripe authentication error:", error)
      this.showError("We could not load your bank's check. Continue to try again or use another card.")
    }
  }

  continue() {
    this.formTarget.requestSubmit()
  }

  showError(message) {
    this.statusTarget.classList.add("d-none")
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("d-none")
    this.continueButtonTarget.classList.remove("d-none")
  }
}
